module.exports = __webpack_public_path__ + "static/media/icon-services.1b3709a8.svg";